<template>
  <router-link
    tag="a"
    v-if="shopId"
    :to="{ name: 'shopsshow', params: { id: shopId } }"
    type="button"
    class="btn btn-sm btn-success go-to-button"
    >Go to shop</router-link
  >
  <button v-else type="button" class="btn btn-sm btn-info go-to-button">register</button>
</template>

<script>
export default {
    name: 'Registered',
    props: {
        shopId: {
            type: [String],
            default: () => ''
        }
    }
};
</script>

<style scoped>
</style>
